import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SimulationResult = ({ result, onWhatsAppConsult, onReset }) => {
  const detailItems = [
    {
      icon: 'Bike',
      label: 'Motor Pilihan',
      value: result?.motorcycleName,
      highlight: false
    },
    {
      icon: 'DollarSign',
      label: 'Harga OTR',
      value: `Rp ${result?.motorcyclePrice?.toLocaleString('id-ID')}`,
      highlight: false
    },
    {
      icon: 'TrendingDown',
      label: 'Uang Muka (DP)',
      value: `Rp ${result?.downPayment?.toLocaleString('id-ID')}`,
      highlight: false
    },
    {
      icon: 'Calendar',
      label: 'Tenor Cicilan',
      value: `${result?.tenor} Bulan`,
      highlight: false
    },
    {
      icon: 'Percent',
      label: 'Suku Bunga',
      value: `${result?.interestRate}% per tahun`,
      highlight: false
    },
    {
      icon: 'CreditCard',
      label: 'Cicilan per Bulan',
      value: `Rp ${result?.monthlyPayment?.toLocaleString('id-ID')}`,
      highlight: true
    },
    {
      icon: 'Calculator',
      label: 'Total Pembayaran',
      value: `Rp ${result?.totalPayment?.toLocaleString('id-ID')}`,
      highlight: false
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mb-2">
          <Icon name="CheckCircle" size={32} color="var(--color-primary)" />
        </div>
        <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground">
          Hasil Simulasi Kredit
        </h3>
        <p className="text-sm text-muted-foreground">
          Berikut estimasi cicilan untuk motor pilihan Anda
        </p>
      </div>
      <div className="bg-gradient-to-br from-primary to-accent p-6 md:p-8 rounded-lg shadow-honda-glow">
        <p className="text-sm text-primary-foreground/80 mb-2">
          Cicilan per Bulan
        </p>
        <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground">
          Rp {result?.monthlyPayment?.toLocaleString('id-ID')}
        </p>
        <p className="text-sm text-primary-foreground/80 mt-2">
          Untuk {result?.tenor} bulan
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {detailItems?.map((item, index) => (
          <div
            key={index}
            className={`p-4 rounded-lg border ${
              item?.highlight
                ? 'border-primary bg-primary/5' :'border-border bg-card'
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                item?.highlight ? 'bg-primary' : 'bg-muted'
              }`}>
                <Icon
                  name={item?.icon}
                  size={20}
                  color={item?.highlight ? 'white' : 'var(--color-primary)'}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground mb-1">
                  {item?.label}
                </p>
                <p className={`font-heading font-bold text-sm md:text-base ${
                  item?.highlight ? 'text-primary' : 'text-foreground'
                }`}>
                  {item?.value}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 md:p-6 bg-muted rounded-lg">
        <div className="flex items-start space-x-3 mb-4">
          <Icon name="AlertCircle" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-heading font-semibold text-foreground mb-2">
              Catatan Penting
            </p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Perhitungan ini adalah estimasi dan dapat berubah</li>
              <li>• Suku bunga aktual ditentukan oleh pihak leasing</li>
              <li>• Biaya administrasi dan asuransi belum termasuk</li>
              <li>• Persetujuan kredit tergantung hasil survey</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          size="lg"
          fullWidth
          iconName="MessageCircle"
          iconPosition="left"
          onClick={onWhatsAppConsult}
          className="shadow-honda-subtle"
        >
          Konsultasi via WhatsApp
        </Button>
        <Button
          variant="outline"
          size="lg"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onReset}
          className="sm:w-auto"
        >
          Hitung Ulang
        </Button>
      </div>
    </div>
  );
};

export default SimulationResult;